import { useGetPiggyRewardsQuery } from "./api/piggyRewardsApi";
import { useAppSelector } from "../../../old/beheer/store";
import { selectSalesAreaId } from "../../SalesAreas/selectors/selectSalesAreaId";
import {
  Box,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { Add } from "@mui/icons-material";
import useConfigureRewardDialog from "./useConfigureRewardDialog";
import { VestigingFormContext } from "../../../old/beheer/views/Vestigingen/VestigingForm";
import { useFormContext } from "react-hook-form";
import TranslationWrapper from "../../../old/beheer/components/TranslationWrapper/TranslationWrapper";
import { Link } from "react-router";

export default function PiggyRewardsV2() {
  const { vestigingId, menukaartVestigingId }: VestigingFormContext = useFormContext<
    MenuResponse & VestigingFormContext
  >();
  const salesAreaId = useAppSelector(selectSalesAreaId);
  const { data, isFetching } = useGetPiggyRewardsQuery(
    { salesAreaId: salesAreaId ?? 0 },
    { skip: (salesAreaId ?? 0) === 0 }
  );
  const configureRewardDialog = useConfigureRewardDialog();

  if (menukaartVestigingId && vestigingId != menukaartVestigingId) {
    return (
      <Box>
        <Typography>
          <TranslationWrapper tKey={"Piggy Rewards must be configured in the menu salesarea"} />
        </Typography>
        <Link to={`../${menukaartVestigingId}/edit?` + location.search}>Salesarea - #{menukaartVestigingId}</Link>
      </Box>
    );
  }

  if (isFetching) {
    return <CircularProgress />;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Status</TableCell>
          <TableCell>Piggy Reward Name</TableCell>
          <TableCell>Jamezz Rewardable type</TableCell>
          <TableCell>Jamezz Rewardable item</TableCell>
          <TableCell>Change reward</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.apiPiggyRewards?.map((apiPiggyReward) => {
          return (
            <TableRow key={apiPiggyReward.id}>
              <TableCell>??</TableCell>
              <TableCell>{apiPiggyReward.title}</TableCell>
              <TableCell>{apiPiggyReward.jamezzPiggyReward?.rewardable_type}</TableCell>
              <TableCell>{apiPiggyReward.jamezzPiggyReward?.rewardable_id}</TableCell>
              <TableCell>
                <IconButton
                  onClick={() => {
                    configureRewardDialog(apiPiggyReward);
                  }}
                >
                  <Add />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
